import {connect} from 'react-redux';

import {mapState, mapDispatch} from '../QCFiltersConnected';
import QCJobsFiltersContainer from './QCJobsFiltersContainer';

export default connect(mapState, mapDispatch)(QCJobsFiltersContainer);
